import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { List } from 'immutable';
import { Fragment, useState, useEffect } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DEFAULT_GOALS, getLastMonthReport, getGoalsFromData, getGoalsFromReport, setGoalsOnReport, isLow
// @ts-expect-error Untyped import
} from './PerformanceUtils';
import GoalsEditor from './GoalsEditor';
// @ts-expect-error Untyped import
import { resolve } from 'reporting-data/main';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Small } from 'foundations-components/transitional/components/Small';
import { Text } from 'foundations-components/components/Text';
import { EVENTS } from '../../../../utils/usageTracker';
import { ReportActionsFloatingAlertStore } from '../../../../shared/ReportActionsFloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MarketingPerformanceEditGoalsModal = ({
  onConfirm,
  onReject,
  report,
  options
}) => {
  const [goals, setGoals] = useState(getGoalsFromReport(report));
  const [lastMonthGoals, setLastMonthGoals] = useState(null);
  useEffect(() => {
    resolve(getLastMonthReport(report)).then(data => {
      setLastMonthGoals(getGoalsFromData(data));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }, [report]);
  const handleChangeReportGoals = newGoals => {
    setGoals(newGoals);
  };
  const handleStartLastMonthClick = () => {
    options.track(EVENTS.clickReportSpecificAction, {
      type: 'LAST_MONTHS_VALUES',
      actionType: 'set-goals'
    });
    handleChangeReportGoals(lastMonthGoals);
  };
  const handleStartScratchClick = () => {
    options.track(EVENTS.clickReportSpecificAction, {
      type: 'DEFAULT_VALUES',
      actionType: 'set-goals'
    });
    handleChangeReportGoals(DEFAULT_GOALS);
  };
  const handleSetGoalsClick = () => {
    options.track(EVENTS.clickReportSpecificAction, {
      actionType: 'set-goals'
    });
    ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reporting-ui-components.customWidgets.editGoals.success"
      })
    });
    onConfirm(setGoalsOnReport(report, goals));
  };
  const handleClearGoals = () => {
    options.track(EVENTS.clickReportSpecificAction, {
      actionType: 'set-goals'
    });
    ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reporting-ui-components.customWidgets.editGoals.deleted"
      })
    });
    onConfirm(setGoalsOnReport(report, null));
  };
  const handleCancel = () => {
    onReject();
  };
  const renderEditGoalsFooter = () => {
    const originalGoals = getGoalsFromReport(report);
    let footerActions = List();
    footerActions = footerActions.push( /*#__PURE__*/_jsx(Button, {
      onClick: handleSetGoalsClick,
      disabled: originalGoals && originalGoals.equals(goals),
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reporting-ui-components.customWidgets.editGoals.action.setGoals"
      })
    }, "setGoals"));
    if (originalGoals) {
      footerActions = footerActions.push( /*#__PURE__*/_jsx(Button, {
        onClick: handleClearGoals,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "reporting-ui-components.customWidgets.editGoals.action.clearGoals"
        })
      }, "clear"));
    }
    footerActions = footerActions.push( /*#__PURE__*/_jsx(Button, {
      onClick: handleCancel,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reporting-ui-components.customWidgets.editGoals.action.cancel"
      })
    }, "cancel"));
    return /*#__PURE__*/_jsx(DialogFooter, {
      children: footerActions
    });
  };
  const renderWelcomeFooter = lowGoalValue => {
    if (lowGoalValue) {
      return /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: handleStartScratchClick,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "reporting-ui-components.customWidgets.editGoals.action.startReady"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onReject,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "reporting-ui-components.customWidgets.editGoals.action.leaveNotReady"
          })
        })]
      }, "footer");
    }
    return /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleStartLastMonthClick,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "reporting-ui-components.customWidgets.editGoals.action.startLastMonth"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleStartScratchClick,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "reporting-ui-components.customWidgets.editGoals.action.startScratch"
        })
      })]
    }, "footer");
  };
  const renderWelcomeBody = () => {
    if (!lastMonthGoals) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 200
      });
    } else {
      const lowGoalValue = isLow(lastMonthGoals);
      const welcomeType = lowGoalValue ? 'lowData' : 'firstGoal';
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsxs(DialogBody, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h1",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `reporting-ui-components.customWidgets.editGoals.goals.${welcomeType}.title`
            })
          }), /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `reporting-ui-components.customWidgets.editGoals.goals.${welcomeType}.subtitle`
            })
          })]
        }, "body"), renderWelcomeFooter(lowGoalValue)]
      });
    }
  };
  const renderWelcomeView = () => {
    return /*#__PURE__*/_jsxs(Modal, {
      onEsc: handleCancel,
      use: "success",
      size: "short",
      width: 540,
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: handleCancel
        })
      }), renderWelcomeBody()]
    });
  };
  const renderGoalEditor = () => {
    return goals && /*#__PURE__*/_jsx(GoalsEditor, {
      goals: goals,
      onChange: handleChangeReportGoals
    });
  };
  const renderModal = (body, footer) => {
    return /*#__PURE__*/_jsxs(Modal, {
      width: 540,
      onEsc: handleCancel,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: handleCancel
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          use: "on-dark",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "reporting-ui-components.customWidgets.editGoals.title"
          })
        })]
      }, "header"), body, footer]
    });
  };
  if (!goals) {
    return renderWelcomeView();
  }
  return renderModal(renderGoalEditor(), renderEditGoalsFooter());
};
export default MarketingPerformanceEditGoalsModal;